(function(){
  if(window.IVRStorieEnhancer){window.IVRStorieEnhancer();return;}

  function youtubeInfo(raw){
    if(!raw)return null;
    try{
      var url=new URL(raw,window.location.origin),host=url.hostname.toLowerCase(),parts=url.pathname.split('/').filter(Boolean),id=null;
      if(host==='youtu.be'||host==='www.youtu.be')id=parts[0];
      else if(['youtube.com','www.youtube.com','m.youtube.com','music.youtube.com','youtube-nocookie.com','www.youtube-nocookie.com'].includes(host)){
        if(parts[0]==='watch')id=url.searchParams.get('v');
        else if(['shorts','embed','live','v'].includes(parts[0]))id=parts[1];
      }
      if(id&&/^[A-Za-z0-9_-]{11}$/.test(id))return {id:id,shorts:parts[0]==='shorts'};
    }catch(e){}
    return null;
  }

  function init(){
    document.querySelectorAll('[data-ivr-storie-portal]').forEach(function(host){
      if(!host.__ivrStorySource || !host.__ivrStorySource.isConnected){
        if(typeof host.__ivrStoryCleanup==='function')host.__ivrStoryCleanup();
        else host.remove();
      }
    });
    document.querySelectorAll('.ivr-storie[data-ugc-stories-section]').forEach(function(wrapper){
      if(wrapper.dataset.ugcInitialized==='true')return;
      var section=wrapper.closest('.shopify-section');
      var anchor=document.getElementById('ancora-ugc-stories');
      if(section&&anchor&&section.parentElement!==anchor)anchor.appendChild(section);
      wrapper.dataset.ugcInitialized='true';

      var items=Array.from(wrapper.querySelectorAll('.ugc-video-item'));
      var carousel=wrapper.querySelector('.ugc-carousel');
      var dotsBox=wrapper.querySelector('.ugc-carousel-dots');
      var modal=wrapper.querySelector('.ugc-video-modal');
      var video=wrapper.querySelector('.ugc-modal-video');
      var iframe=wrapper.querySelector('.ugc-modal-youtube');
      var progress=wrapper.querySelector('.ugc-modal-progress-bar');
      var product=wrapper.querySelector('.ugc-modal-product');
      var image=wrapper.querySelector('.ugc-modal-img');
      var title=wrapper.querySelector('.ugc-modal-title');
      var price=wrapper.querySelector('.ugc-modal-price');
      var close=wrapper.querySelector('.ugc-modal-close');
      var prev=wrapper.querySelector('.ugc-prev');
      var next=wrapper.querySelector('.ugc-next');
      var floatTrigger=wrapper.querySelector('.ugc-floating-trigger');
      var floatImg=wrapper.querySelector('.ugc-floating-trigger-image');
      var floatVideo=wrapper.querySelector('.ugc-floating-trigger-video');
      var floatPrev=wrapper.querySelector('.ugc-floating-prev');
      var floatNext=wrapper.querySelector('.ugc-floating-next');
      var storyCounter=null;
      var floating=wrapper.classList.contains('is-floating');
      var centerOnOpen=floating&&wrapper.dataset.openPosition!=='corner';
      var youtubeHideControls=wrapper.dataset.youtubeHideControls!=='false';
      var nativeControls=wrapper.dataset.nativeControls==='true';
      var preview=wrapper.dataset.preview==='true'&&!floating;
      var active=null;
      var closeTimer=null;
      var touchY=0,touchX=0;
      var touchStartEligible=false;
      var suppressClickUntil=0;

      if(!carousel||!modal||!items.length)return;

      var overlayHost=document.createElement('div');
      overlayHost.className=wrapper.className+' ivr-storie-portal';
      overlayHost.setAttribute('data-ivr-storie-portal',wrapper.dataset.ugcStoriesSection||'');
      overlayHost.setAttribute('data-float-side',wrapper.dataset.floatSide||'right');
      overlayHost.setAttribute('data-open-position',wrapper.dataset.openPosition||'center');
      overlayHost.setAttribute('data-show-mobile',wrapper.dataset.showMobile||'true');
      overlayHost.setAttribute('data-show-desktop',wrapper.dataset.showDesktop||'true');
      overlayHost.style.cssText=wrapper.getAttribute('style')||'';
      overlayHost.style.setProperty('margin','0','important');
      overlayHost.style.setProperty('padding','0','important');
      overlayHost.style.setProperty('height','0','important');
      overlayHost.style.setProperty('min-height','0','important');
      overlayHost.style.setProperty('width','0','important');
      overlayHost.style.setProperty('overflow','visible','important');
      overlayHost.style.setProperty('position','static','important');
      overlayHost.style.setProperty('transform','none','important');
      overlayHost.__ivrStorySource=wrapper;
      if(floatTrigger)overlayHost.appendChild(floatTrigger);
      overlayHost.appendChild(modal);
      document.body.appendChild(overlayHost);

      var fullScreen=!floating||centerOnOpen;
      var returningFocus=null;
      var scrollLocked=false;

      function lockPageScroll(){
        if(!fullScreen||scrollLocked)return;
        var root=document.documentElement;
        var count=Number(root.dataset.ivrStoryLockCount)||0;
        if(count===0){
          root.dataset.ivrStoryPreviousOverflow=root.style.overflow;
          document.body.dataset.ivrStoryPreviousOverflow=document.body.style.overflow;
          root.classList.add('ivr-storie-scroll-lock');
          document.body.classList.add('ivr-storie-scroll-lock');
        }
        root.dataset.ivrStoryLockCount=String(count+1);
        scrollLocked=true;
      }

      function unlockPageScroll(){
        if(!scrollLocked)return;
        var root=document.documentElement;
        var count=Number(root.dataset.ivrStoryLockCount)||0;
        if(count<=1){
          root.classList.remove('ivr-storie-scroll-lock');
          document.body.classList.remove('ivr-storie-scroll-lock');
          root.style.overflow=root.dataset.ivrStoryPreviousOverflow||'';
          document.body.style.overflow=document.body.dataset.ivrStoryPreviousOverflow||'';
          delete root.dataset.ivrStoryPreviousOverflow;
          delete document.body.dataset.ivrStoryPreviousOverflow;
          delete root.dataset.ivrStoryLockCount;
        }else{
          root.dataset.ivrStoryLockCount=String(count-1);
        }
        scrollLocked=false;
      }

      function openDialogLayer(){
        if(modal.hasAttribute('open'))return;
        if(fullScreen&&typeof modal.showModal==='function'){
          try{modal.showModal();return;}catch(error){}
        }
        if(typeof modal.show==='function'){
          try{modal.show();return;}catch(error){}
        }
        modal.setAttribute('open','');
      }

      function closeDialogLayer(){
        if(typeof modal.close==='function'&&modal.open){
          try{modal.close();return;}catch(error){}
        }
        modal.removeAttribute('open');
      }

      function isEnabledForViewport(){
        if(!floating)return true;
        var mobile=window.matchMedia&&window.matchMedia('(max-width: 767px)').matches;
        return mobile?wrapper.dataset.showMobile!=='false':wrapper.dataset.showDesktop!=='false';
      }

      wrapper.classList.toggle('has-multiple',items.length>1);
      overlayHost.classList.toggle('has-multiple',items.length>1);
      if(items.length>1){
        var playerFrame=modal.querySelector('.ugc-modal-video-wrapper');
        if(playerFrame){
          storyCounter=document.createElement('span');
          storyCounter.className='ugc-story-counter';
          storyCounter.setAttribute('role','status');
          storyCounter.setAttribute('aria-live','polite');
          storyCounter.setAttribute('aria-atomic','true');
          playerFrame.appendChild(storyCounter);
        }
      }

      function cover(item){
        return item.dataset.poster||((item.dataset.youtubeId)?'https://i.ytimg.com/vi/'+item.dataset.youtubeId+'/hqdefault.jpg':'');
      }

      items.forEach(function(item){
        var yt=youtubeInfo(item.dataset.video);
        if(!yt)return;
        item.dataset.youtubeId=yt.id;
        item.dataset.isShorts=yt.shorts?'true':'false';
        var thumb=item.querySelector('.ugc-video-inner');
        if(!thumb)return;
        var old=thumb.querySelector('video');
        if(old)old.remove();
        var img=document.createElement('img');
        img.className='ugc-story-youtube-image';
        img.src=cover(item);
        img.alt='';
        img.loading='lazy';
        img.decoding='async';
        thumb.appendChild(img);
        var play=document.createElement('span');
        play.className='ugc-story-play';
        play.setAttribute('aria-hidden','true');
        play.textContent='▶';
        thumb.appendChild(play);
      });

      if(floating&&floatTrigger){
        var first=items[0],thumb=cover(first);
        if(thumb&&floatImg){
          floatImg.src=thumb;
          floatTrigger.classList.add('has-image');
        }else if(floatVideo&&first.dataset.video&&!first.dataset.youtubeId){
          floatVideo.src=first.dataset.video;
          floatTrigger.classList.add('has-video');
        }
      }

      function stopMedia(){
        if(video){
          video.pause();
          video.removeAttribute('src');
          video.removeAttribute('poster');
          video.controls=false;
          video.load();
        }
        if(iframe)iframe.removeAttribute('src');
      }

      function closePlayer(){
        if(!modal.classList.contains('active'))return;
        modal.classList.remove('active','is-ready');
        wrapper.classList.remove('is-floating-open');
        overlayHost.classList.remove('is-floating-open');
        if(iframe)iframe.src='about:blank';
        if(video)video.pause();
        clearTimeout(closeTimer);
        closeTimer=setTimeout(function(){
          if(!modal.classList.contains('active')){
            stopMedia();
            modal.classList.remove('is-youtube');
            if(progress)progress.style.width='0%';
            closeDialogLayer();
            unlockPageScroll();
            if(returningFocus&&returningFocus.isConnected){
              try{returningFocus.focus({preventScroll:true});}
              catch(error){returningFocus.focus();}
            }
            returningFocus=null;
          }
        },350);
        if(preview&&active){
          var thumb=active.querySelector('video[data-src]');
          if(thumb)thumb.play().catch(function(){});
        }
        active=null;
      }

      function openPlayer(item,auto){
        if(!item||!isEnabledForViewport())return;
        clearTimeout(closeTimer);
        if(!modal.classList.contains('active')){
          returningFocus=auto?null:document.activeElement;
        }
        active=item;
        item.classList.add('is-watched');
        if(storyCounter){
          var currentStoryIndex=items.indexOf(item);
          storyCounter.textContent=(currentStoryIndex+1)+' / '+items.length;
          storyCounter.setAttribute('aria-label','Vídeo '+(currentStoryIndex+1)+' de '+items.length);
        }
        var previewVideo=item.querySelector('video[data-src]');
        if(previewVideo)previewVideo.pause();
        modal.classList.remove('is-ready');
        stopMedia();

        var yt=item.dataset.youtubeId;
        var fmt=item.dataset.videoFormat||'auto';
        var aspect=Number(item.dataset.videoAspect)||0;
        var wide=fmt==='horizontal'||(fmt==='auto'&&((yt&&item.dataset.isShorts!=='true')||(!yt&&aspect>1.3)));
        modal.style.setProperty('--ivr-story-ratio',wide?'16 / 9':'9 / 16');
        modal.classList.toggle('is-youtube',Boolean(yt));
        modal.classList.toggle('is-landscape',Boolean(wide));

        openDialogLayer();
        lockPageScroll();

        if(yt&&iframe){
          iframe.src='https://www.youtube-nocookie.com/embed/'+yt+'?autoplay=1&playsinline=1&controls='+(youtubeHideControls?'0':'1')+'&rel=0'+(youtubeHideControls?'&fs=0':'')+(auto?'&mute=1':'');
        }else if(video){
          video.src=item.dataset.video||'';
          video.muted=Boolean(auto);
          video.controls=nativeControls;
          if(item.dataset.poster)video.poster=item.dataset.poster;
          video.play().catch(function(){
            video.muted=true;
            video.play().catch(function(){});
          });
        }

        if(progress)progress.style.width='0%';
        if(product&&item.dataset.productUrl){
          product.href=item.dataset.productUrl;
          product.style.display='flex';
          if(image)image.src=item.dataset.productImage||'';
          if(title)title.textContent=item.dataset.productTitle||'';
          if(price)price.textContent=item.dataset.productPrice||'';
        }else if(product)product.style.display='none';

        modal.classList.add('active');
        if(floating){
          wrapper.classList.add('is-floating-open');
          overlayHost.classList.add('is-floating-open');
        }
        if(fullScreen&&!auto&&close){
          try{close.focus({preventScroll:true});}
          catch(error){close.focus();}
        }
      }

      if(video){
        video.addEventListener('loadedmetadata',function(){
          if(!active||modal.classList.contains('is-youtube'))return;
          if(active.dataset.videoFormat==='auto'&&video.videoHeight){
            modal.style.setProperty('--ivr-story-ratio',video.videoWidth/video.videoHeight>1.3?'16 / 9':'9 / 16');
            modal.classList.toggle('is-landscape',video.videoWidth/video.videoHeight>1.3);
          }
        });
        if(floating){
          function toggleVideoByUser(){
            if(Date.now()<suppressClickUntil)return;
            if(video.muted){
              video.muted=false;
              if(video.paused)video.play().catch(function(){});
            }else if(video.paused){
              video.play().catch(function(){});
            }else{
              video.pause();
            }
          }
          video.addEventListener('click',toggleVideoByUser);
          video.addEventListener('keydown',function(event){
            if(event.key==='Enter'||event.key===' '){event.preventDefault();toggleVideoByUser();}
          });
        }
        video.addEventListener('playing',function(){
          if(modal.classList.contains('active')&&!modal.classList.contains('is-youtube'))modal.classList.add('is-ready');
        });
        video.addEventListener('timeupdate',function(){
          if(progress&&Number.isFinite(video.duration)&&video.duration>0){
            progress.style.width=Math.min(100,(video.currentTime/video.duration)*100)+'%';
          }
        });
      }
      if(iframe)iframe.addEventListener('load',function(){
        if(modal.classList.contains('active')&&modal.classList.contains('is-youtube'))modal.classList.add('is-ready');
      });

      items.forEach(function(item){
        var thumb=item.querySelector('.ugc-video-inner');
        if(!thumb)return;
        thumb.addEventListener('click',function(){openPlayer(item,false);});
        thumb.addEventListener('keydown',function(ev){
          if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();openPlayer(item,false);}
        });
      });
      if(floatTrigger)floatTrigger.addEventListener('click',function(){openPlayer(items[0],false);});
      if(close)close.addEventListener('click',function(ev){ev.stopPropagation();closePlayer();});
      function slideStory(delta){
        if(items.length<2||!active||!modal.classList.contains('active'))return;
        var index=items.indexOf(active);
        var targetIndex=(index+delta+items.length)%items.length;
        openPlayer(items[targetIndex],false);
      }
      if(floatPrev)floatPrev.addEventListener('click',function(ev){ev.stopPropagation();slideStory(-1);});
      if(floatNext)floatNext.addEventListener('click',function(ev){ev.stopPropagation();slideStory(1);});
      modal.addEventListener('click',function(ev){
        if(Date.now()<suppressClickUntil)return;
        if(ev.target===modal)closePlayer();
      });
      modal.addEventListener('touchstart',function(ev){
        touchStartEligible=false;
        if(!ev.changedTouches.length||ev.touches.length>1)return;
        if(ev.target.closest&&ev.target.closest('.ugc-modal-product,.ugc-modal-close,.ugc-floating-nav'))return;
        touchY=ev.changedTouches[0].clientY;
        touchX=ev.changedTouches[0].clientX;
        touchStartEligible=true;
      },{passive:true});
      modal.addEventListener('touchcancel',function(){touchStartEligible=false;},{passive:true});
      modal.addEventListener('touchend',function(ev){
        if(!touchStartEligible||!ev.changedTouches.length||!modal.classList.contains('active'))return;
        touchStartEligible=false;
        var deltaX=ev.changedTouches[0].clientX-touchX;
        var deltaY=ev.changedTouches[0].clientY-touchY;
        var absX=Math.abs(deltaX),absY=Math.abs(deltaY);
        if(items.length>1&&absX>50&&absX>absY*1.25){
          suppressClickUntil=Date.now()+450;
          slideStory(deltaX<0?1:-1);
          return;
        }
        if(!floating&&deltaY>85&&absY>absX*1.4){
          suppressClickUntil=Date.now()+450;
          closePlayer();
        }
      },{passive:true});
      function handleEscape(ev){
        if(!modal.classList.contains('active'))return;
        if(ev.key==='Escape'){
          closePlayer();
          return;
        }
        if(items.length<2||ev.altKey||ev.ctrlKey||ev.metaKey)return;
        if(ev.target.closest&&ev.target.closest('input,textarea,select,[contenteditable="true"]'))return;
        if(ev.key==='ArrowRight'||ev.key==='ArrowLeft'){
          ev.preventDefault();
          slideStory(ev.key==='ArrowRight'?1:-1);
        }
      }
      document.addEventListener('keydown',handleEscape);
      modal.addEventListener('cancel',function(event){
        event.preventDefault();
        closePlayer();
      });
      modal.addEventListener('close',function(){
        if(modal.classList.contains('active'))closePlayer();
      });
      function handleViewportChange(){
        if(modal.classList.contains('active')&&!isEnabledForViewport())closePlayer();
      }
      window.addEventListener('resize',handleViewportChange);

      if(floating){
        if(wrapper.dataset.floatingStart==='true'){
          if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches)openPlayer(items[0],true);
        }
      }else{
        if('IntersectionObserver' in window){
          var dotObserver=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if(!entry.isIntersecting)return;
              var index=items.indexOf(entry.target);
              if(!dotsBox)return;
              dotsBox.querySelectorAll('span').forEach(function(dot,i){dot.classList.toggle('active',i===index);});
            });
          },{threshold:.6,root:carousel});
          items.forEach(function(item,index){
            if(dotsBox){
              var dot=document.createElement('span');
              dot.classList.toggle('active',index===0);
              dot.setAttribute('role','button');
              dot.tabIndex=0;
              dot.setAttribute('aria-label','Ir para story '+(index+1));
              var go=function(){item.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});};
              dot.addEventListener('click',go);
              dot.addEventListener('keydown',function(ev){if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();go();}});
              dotsBox.appendChild(dot);
            }
            dotObserver.observe(item);
          });
          var thumbObserver=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              var thumb=entry.target;
              if(entry.isIntersecting){
                if(!thumb.src&&thumb.dataset.src){thumb.src=thumb.dataset.src;thumb.load();}
                if(preview&&!modal.classList.contains('active')){
                  thumb.muted=true;
                  thumb.loop=true;
                  thumb.play().catch(function(){});
                }
              }else if(preview&&!thumb.paused){thumb.pause();}
            });
          },{rootMargin:'50px 0px'});
          wrapper.querySelectorAll('video[data-src]').forEach(function(thumb){thumbObserver.observe(thumb);});
        }else{
          wrapper.querySelectorAll('video[data-src]').forEach(function(thumb){thumb.src=thumb.dataset.src;});
        }
        function scroll(delta){
          if(!items.length)return;
          var gap=parseInt(getComputedStyle(carousel).gap,10)||0;
          carousel.scrollBy({left:delta*(items[0].offsetWidth+gap),behavior:'smooth'});
        }
        if(prev)prev.addEventListener('click',function(){scroll(-1);});
        if(next)next.addEventListener('click',function(){scroll(1);});
      }

      function cleanupStorySection(){
        clearTimeout(closeTimer);
        modal.classList.remove('active','is-ready');
        if(iframe)iframe.src='about:blank';
        stopMedia();
        closeDialogLayer();
        unlockPageScroll();
        document.removeEventListener('keydown',handleEscape);
        document.removeEventListener('shopify:section:unload',onSectionUnload);
        window.removeEventListener('resize',handleViewportChange);
        if(overlayHost.isConnected)overlayHost.remove();
      }
      function onSectionUnload(event){
        if(event.detail&&event.detail.sectionId===wrapper.dataset.ugcStoriesSection){
          cleanupStorySection();
        }
      }
      overlayHost.__ivrStoryCleanup=cleanupStorySection;
      document.addEventListener('shopify:section:unload',onSectionUnload);
    });
  }

  window.IVRStorieEnhancer=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();